import { createBrowserRouter } from "react-router-dom";

import Layout from "../Layout";
import Assessments from "../pages/Assessments";
import Dashboard from "../pages/Dashboard";
import Settings from "../pages/Settings";
import Create from "../pages/CreateAssessment";
import AssessmentReport from "../pages/Reports";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <Dashboard /> },
      { path: "/assessments", element: <Assessments /> },
      { path: "/settings", element: <Settings /> },
      { path: "/edit/:assessmentId", element: <Create /> },
      { path: "/report/:assessmentId", element: <AssessmentReport /> },
    ],
  },
]);

export default router;
